import type { Language } from '@openeducation/pp-rn-shared-types';

import { atomWithAsyncStorage } from '../utils';

export const preferredLanguageAtom = atomWithAsyncStorage<Language | null>(
  'language',
  null
);
